// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"387":"1712bf50","3411":"1712bf50","3613":"1712bf50","7742":"71dcd781","8157":"1712bf50"}[chunkId] + ".chunk.css";
};